import './Editable.scss';
import Component from './Editable.js';
export default Component;
